<div class="narrow-container p-48:v md:p-72:v lg:p-96:v align:c">
    <h1>In guten Händen</h1>
    <p class="lg:fs:l">
        Die astra Versicherung steht für Einfachheit, Transparenz und Kommunikation auf Augenhöhe. Unser Anspruch ist,
        Dir einen exzellenten Service und attraktive Konditionen zu bieten. Werde ein Teil unserer starken Gemeinschaft.
    </p>
    <p class="lg:fs:l">Wir sind ein Team.</p>

    <h2 class="m-48:v">Wir sind Mitglied im</h2>
    <ul class="partner-logo-list p-0:l grid-container -center-content">
        <li class="partner-logo-image g-12 p-24">
            <img
                src="assets/img/partner-logos/partner_logo_gdv.svg"
                alt="Gesamtverband der Deutschen Versicherungswirtschaft"
                class="logo-gdv img:fluid img:center"
                width="480px"
                height="71px"
            />
        </li>
    </ul>
</div>
